<template>
  <div class="flex flex-row flex-wrap">
    <Field name="requestNumber" v-slot="{ field, errors: errs }">
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('requestNumber')"
        :maxLength="80"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
      />
    </Field>
    <Field
      name="servicesTransactions"
      v-slot="{ field, errors: errs, handleChange }"
      class="w-full"
    >
      <MultipleDropdownSearch
        :field="field"
        :errors="errs"
        :options="serviceTypeList"
        optionValue="label"
        :label="$t('Services')"
        :placeholder="$t('Services')"
        class="lg:w-1/2 flex-col px-2 w-full"
        direction="flex-col"
        labelClass="w-full "
        @on-selection="(item) => handleChange(item)"
      />
    </Field>

    <Field name="receiptNumber" v-slot="{ field, errors: errs }">
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('receiptNumber')"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
      />
    </Field>

    <Field name="paymentRefId" v-slot="{ field, errors: errs }" class="w-full">
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('bankRefernaceNumber')"
        class="lg:w-1/2 flex-col px-2 w-full"
        direction="flex-col"
        :isRequired="false"
      />
    </Field>

    <Field :rules="isRequired" name="startDate" v-slot="{ field, errors: errs, handleChange }">
      <SimpleDatepicker
        :field="field"
        :errors="errs"
        :label="$t('startDate')"
        :max-date="startMaxDateRef"
        class="lg:w-1/2 flex-col px-2 w-full"
        :defaultValue="field.value"
        @on-change="(date) => handleChange(date)"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>

    <Field :rules="isRequired" name="endDate" v-slot="{ field, errors: errs, handleChange }">
      <SimpleDatepicker
        :field="field"
        :errors="errs"
        :label="$t('endDate')"
        :min-date="endMinDateRef"
        class="lg:w-1/2 flex-col px-2 w-full"
        :defaultValue="props.initialValues.endDate"
        @on-change="(date) => handleChange(date)"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>
    <Field
      name="paymentMethodId"
      v-slot="{ field, errors: errs, handleChange }"
      class="w-full"
      v-if="paymentMethodList.length"
    >
      <SimpleDropdown
        :field="field"
        :errors="errs"
        :label="$t('paymentMethod')"
        placeholder="pleaseSelect"
        :options="paymentMethodList"
        :is-required="false"
        direction="flex-col"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-selection="
          (item) => {
            handleChange(+item?.id)
          }
        "
      ></SimpleDropdown>
    </Field>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { Field } from 'vee-validate'

import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import MultipleDropdownSearch from '@/components/SimpleForm/MultiSelect.vue'

import { DateTime } from 'luxon'

import { useLookupsStore } from '@/stores/lookups'

const lookupsStore = useLookupsStore()

const props = defineProps({
  initialValues: Object,
  isShowFingerprintCheckbox: {
    type: Boolean,
    default: false
  },
  values: {
    type: Object,
    default: () => ({})
  }
})
const serviceTypeList = ref([])
const paymentMethodList = ref([])

const fetchServiceTypeList = async () => {
  const res = await lookupsStore.fetchLookup('/api/servicesTransactions')
  serviceTypeList.value = res.map((item) => {
    item.value = item.id
    item.code = item.id
    return item
  })
}
const fetchPaymentMethodList = async () => {
  const res = await lookupsStore.fetchLookup('/api/lookup/GetPaymentMethods')
  paymentMethodList.value = res.map((item) => {
    item.value = item.id
    item.code = item.id
    return item
  })
}

function isRequired(value) {
  if (value && `${value}`.trim()) {
    return true
  }

  return 'INVALID_REQUIRED'
}

const formateDate = (currentDate) => {
  return DateTime.fromFormat(currentDate, 'yyyy/MM/dd').toFormat('dd/MM/yyyy')
}

const startMaxDateRef = computed(() => {
  if (props.values.endDate) {
    return formateDate(props.values.endDate)
  } else {
    return DateTime.now().toFormat('dd/MM/yyyy')
  }
})

const endMinDateRef = computed(() => {
  if (props.values.startDate) {
    return formateDate(props.values.startDate)
  }
  return ''
})

onMounted(async () => {
  await fetchServiceTypeList()
  await fetchPaymentMethodList()
})
</script>

<style></style>
